export default {
  iHaveTheReferral: 1,
  iHaveThePaperReferral: 2,
  iDontHaveTheReferral: 3
};
